import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Tabs } from 'antd'
import { AutoWorkFlow } from 'components/Purchasing/DeliveryOrder/AddDeliveryOrder/AutoWorkFlow'
import { OrdersApi as PurchaseOrdersApi } from '../../../../api/Purchase/Orders'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../components/Common/Email/EmailCont'
import History from '../../../../components/Common/History'
import Tracking from '../../../../components/Common/Tracking'
import MRNCont from '../../../../components/HSEQ/MRN/MRNCont'
import DeliveryOrderForm from '../../../../components/Purchasing/DeliveryOrder/DeliveryOrderForm'
import DeliveryOrderLinesCont from '../../../../components/Purchasing/DeliveryOrder/Lines/DeliveryOrderLinesCont'
import OrderList from '../../../../components/Purchasing/Order/OrderList'
import PackingCont from '../../../../components/Purchasing/Order/PackingList/PackingCont'
import PackageCont from '../../../../components/Purchasing/Packages/PackageCont'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'
import IconText from '../../../../elements/IconText'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import _, { get, isEmpty } from 'lodash'
import { idMaker, strVal } from '../../../../modules/Utils'
import moment from 'moment'
import React, { Fragment } from 'react'
import EmailListCont from '../../../Main/Emails/EmailCont'
import TimelineFeedCont from '../../../Common/TimelineFeed/TimelineFeedCont'
import TaskSystemList from '../../../Operations/TaskSystem/List'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'

AddDeliveryOrder.propTypes = {}
const ids = idMaker()

function AddDeliveryOrder(props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    delivery,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    isNew,
    onShowEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
  } = props

  const isApproved = delivery.status === 'Approved'

  const { list: cachedListPOrders, fetching: fetchingPOrders, fetch: fetchPOrders } = useFetchList(
    () => PurchaseOrdersApi.getPOrdersByDeliveryOrder(delivery._key),
    [delivery._key],
    isEmpty(delivery._key)
  )

  const { list: listPOrders, company: companyPOrder, onChangeCompany: onChangeCompanyPOrder } = useListCompanyFilter(
    cachedListPOrders,
    fetchingPOrders
  )

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )
  const Operations = ({ delivery, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    if (ops.length > 0 && isApproved) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }

    // if (ops.length > 0 && isApproved) {
    //   ops.push(
    //     <span>
    //       <Popconfirm
    //         placement="left"
    //         title={`Are you sure to Duplicate?`}
    //         onConfirm={() => handleActions('duplicate')}
    //         okText="Yes"
    //         cancelText="No">
    //         <a>Duplicate</a>
    //       </Popconfirm>
    //     </span>,
    //   )
    // }
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const { data: tracking, fetching: fetchingTracking } = useFetchURL(
    `foxxapi/tracking?select=*&deliveryOrder=${delivery._key}&lines=true`,
    [delivery._key],
    isEmpty(delivery._key)
  )

  const { list: listTasks, fetching: fetchingTasks, fetch: fetchTasks } = useFetchList(
    () => EnquiriesApi.tasks(get(delivery, 'enquiry._id').replace('activities/','')),
    [get(delivery, 'enquiry._id')],
    isEmpty(get(delivery, 'enquiry._id'))
  )

  const listTrackingLine = get(tracking[0], 'lines', []).sort((a, b) => moment(b.date).diff(moment(a.date)))[0]

  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={'Delivery Order'}
        link={{
          pathname: `/clients/orders/${_.get(delivery, 'sales._id', '').replace('sales/', '')}/update`,
        }}
        name={_.get(delivery, 'sales.title')}
        visible={!_.isEmpty(_.get(delivery, 'sales'))}
        type={'Sales Order'}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item href="#/purchasing/delivery/list">Delivery Orders</Breadcrumb.Item>
            <Breadcrumb.Item>{isNew ? 'New Delivery Order' : delivery.code}</Breadcrumb.Item>
          </Breadcrumb>
          {isNew && <h2 className={style.title}>New Delivery Order</h2>}
          {!isNew && (
            <Fragment>
              <Col span={14}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(delivery, 'code')} title={'Delivery Code'} />
                  <Status value={strVal(delivery, 'status')} />
                  <Operations style={{ marginTop: '10px' }} delivery={delivery} status={strVal(delivery, 'status')} />
                  {isApproved && <AutoWorkFlow owner={delivery} />}
                </h3>
              </Col>
              {get(tracking, '[0]trackingNumber') && (
                <Col span={10}>
                  <Tracking
                    id={get(tracking, '[0]_key')}
                    trackingNumber={get(tracking, '[0]trackingNumber')}
                    data={[
                      { name: 'Tracking Number', value: get(tracking, '[0]trackingNumber') },
                      {
                        name: 'Created',
                        value: moment(get(tracking, '[0]date')).format('YYYY-MM-DD'),
                      },
                      {
                        name: 'Last Location',
                        value: listTrackingLine && listTrackingLine.location,
                      },
                      {
                        name: 'Last Update',
                        value: listTrackingLine && moment(listTrackingLine.date).format('YYYY-MM-DD HH:mm:ss'),
                      },
                    ]}
                  />
                </Col>
              )}
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <EmailCont
          key={ids.next().value}
          visible={visibleEmail}
          onCancel={onCancelEmail}
          template={emailTemplate}
          email={emailDetails}
          files={emailFiles}
          lines={emailLines}
        />
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <DeliveryOrderForm ref={formRef} {...props} />
            {isUpdatable && <SubmitButton />}
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab={'Delivery Lines'} key="#lines">
            <DeliveryOrderLinesCont {...{ isUpdatable, delivery }} />
          </Tabs.TabPane>
          {get(delivery, 'enquiry._id') && (
          <Tabs.TabPane tab={'Tasks & Notes'} key="#tasks-notes">
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Notes" key="1">
                <TimelineFeedCont {...{ owner: get(delivery, 'enquiry._id'), hideNotification: true }} />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tasks" key="2">
                <TaskSystemList
                  fetching={fetchingTasks}
                  fetch={fetchTasks}
                  list={listTasks}
                  hideCompany={true}
                  enquiry={delivery.enquiry}
                />
              </Tabs.TabPane>
            </Tabs>
          </Tabs.TabPane>
          )}
          <Tabs.TabPane disabled={isNew} tab={'Release Notes'} key="#releaseNotes">
            <MRNCont delivery={delivery} />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Packages
              </span>
            }
            disabled={isNew}
            key="Packages">
            <PackageCont delivery={delivery} />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <span>
                <Icon type="ordered-list" /> Packing List
              </span>
            }
            disabled={isNew}
            key="PackingList">
            <PackingCont delivery={delivery} />
          </Tabs.TabPane>

          <Tabs.TabPane
            disabled={isNew}
            tab={
              <span>
                <Icon type="file-text" />
                Vendor Order
              </span>
            }
            key="#vendor">
            <OrderList
              {...{
                listOrders: listPOrders,
                fetchingOrders: fetchingPOrders,
                fetchOrders: fetchPOrders,
                companyOrder: companyPOrder,
                onChangeCompanyOrder: onChangeCompanyPOrder,
                hideCompany: true,
              }}
            />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab={'Freight Bookings'} key="#bookings">
            <OrderList {...props} />
          </Tabs.TabPane>
          {/*<Tabs.TabPane disabled={isNew} tab={'Delivery Dockets'} key="#deliveryDockets" />*/}
          <Tabs.TabPane tab="Email" key="#email">
            <EmailListCont owner={delivery._id} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Documents" key="files">
            <Documents
              key={delivery._rev}
              editable={true}
              footer={false}
              category={false}
              email={true}
              owner={delivery}
            />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={delivery} key={delivery._rev} isArray={true} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddDeliveryOrder
